import { render, staticRenderFns } from "./YLIDValidation.vue?vue&type=template&id=59a90209&scoped=true"
import script from "./YLIDValidation.vue?vue&type=script&lang=js"
export * from "./YLIDValidation.vue?vue&type=script&lang=js"
import style0 from "./YLIDValidation.vue?vue&type=style&index=0&id=59a90209&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a90209",
  null
  
)

export default component.exports